import i18n from "../../../i18n/index"
export default {
    data() {
        return {
            branchCitiesDetail:[],
            search: "",
            pagination: {},
            headers: [
              {
                text: i18n.t('headers.state'),
                sortable: false,
                value: "resource"
              },
              {
                text: i18n.t('headers.city'),
                sortable: false,
                value: "name"
              }
            ]
        }
    },
    methods: {
        addData(item){
        this.branchCitiesDetail = item.branchCities
        },
        showFunction(){
            this.$emit("showFunction")
        }
    },
    //props: { branchCitiesDetail: { type: Function, default: () => { } } },

}